import { injectReducer } from "../../store/reducers";
import { isLoggedIn } from "../../utils/auth";
import { loyaltyPointsReducer, loyaltyPointsRedeemReducer, sendOtpReducer } from "./modules/LoyaltyRedeem";
import { generateOTPReducer } from "../OfferActivation/modules/OfferActivation";
import {
  loadCustomerGiftVouchersReducer,
  validateOTPReducer as giftVoucherValidateOTPReducer,
  generateOTPReducer as giftVoucherGenerateOTPReducer,
} from "../GiftVoucherActivation/modules/GiftVoucherActivation";

export default (store) => ({
  path: "loyalty-redeem",
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      (require) => {
        /*  Webpack - use require callback to define
          dependencies for bundling   */
        const RedemptionTabs = require("./containers/RedemptionTabs").default;
        injectReducer(store, {
          key: "loyaltyPoints",
          reducer: loyaltyPointsReducer,
        });
        injectReducer(store, {
          key: "loyaltyPointsRedeem",
          reducer: loyaltyPointsRedeemReducer,
        });
        injectReducer(store, {
          key: "otpInfo",
          reducer: generateOTPReducer,
        });
        injectReducer(store, {
          key: "customerGiftVouchers",
          reducer: loadCustomerGiftVouchersReducer,
        });
        injectReducer(store, {
          key: "giftVoucherValidatedOtpInfo",
          reducer: giftVoucherValidateOTPReducer,
        });
        injectReducer(store, {
          key: "giftVoucherOtpInfo",
          reducer: giftVoucherGenerateOTPReducer,
        });
        cb(null, RedemptionTabs);
        /* Webpack named bundle   */
      },
      "loyaltyRedeem"
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/LoyaltyRedeem/index.js